import React from "react";

import MerchantDropdown from "../../../../../MerchantDropdown";
import {Link, path$} from "../../../../../../../../../router";

import MerchantNavigationItemInner from "../MerchantNavigationItemInner";
import {isUserAccessed} from "../../../../../../../../../emitters/account";

const permissionCheck = (el) => {
  const permissions = el.permissions || [];
  if (!permissions.length) return true;
  return permissions.every((pemission) => isUserAccessed(pemission));
}

export default ({id, baseClassName, className, subLinks = [], ...props}) => {
  const checkPermissions = (perm) => !isUserAccessed(perm);

  return (
    <MerchantDropdown
      id={id}
      className={className}
      btnProps={{'data-testid': id}}
      itemsList={
        subLinks.filter(permissionCheck).map((el) => {
          if (el.separator) return el;

          const active = path$.getValue().startsWith(el.link);

          let disabled = false;

          if ((el.permissions || []).length) {
            disabled = el.permissions.some(checkPermissions);
          }

          const linkClassName = [
            `${baseClassName}__dropdown-link`,
            !!active ? ' active' : '',
            !!disabled ? ' disabled' : ''
          ].join(' ');

          return (
            <Link
              className={linkClassName}
              data-testid={el.id}
              href={!disabled ? el.link : ''}
            >
              {el.name}
            </Link>
          )
        })
      }
    >
      <MerchantNavigationItemInner {...props} />
    </MerchantDropdown>
  );
}
